import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import useAccountConfig from '../hooks/useAccountConfig';

const AccountConfigContext = createContext();

export const AccountConfigProvider = ({ children }) => {
  const value = useAccountConfig();
  return (
    <AccountConfigContext.Provider value={value}>
      {children}
    </AccountConfigContext.Provider>
  );
};

AccountConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAccountConfigContext = () => useContext(AccountConfigContext);
